import { readState } from "@/__main__/app-state.mjs";
import getData from "@/__main__/get-data.mjs";
import UnknownMatch from "@/data-models/unknown-match.mjs";
import UnknownMatchList, {
  fixture as matchListFixture,
} from "@/data-models/unknown-matchlist.mjs";
import UnknownPlayer, {
  fixture as playerFixture,
} from "@/data-models/unknown-player.mjs";
import definition from "@/game-unknown/definition.mjs";
import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";

const routes: BaseRoute[] = [
  {
    path: /^\/unknown\/profile\/(.*?)$/,
    component: "game-unknown/Profile.jsx",
    async fetchData([name], urlSearchParams, state) {
      if (!state || !state.transient?.visibleMatches?.[definition.shortName]) {
        await getData({ ...playerFixture, name }, UnknownPlayer, [
          "unknown",
          "profiles",
          name,
        ]);

        await getData(matchListFixture, UnknownMatchList, [
          "unknown",
          "matchLists",
          name,
        ]);
        return;
      }

      // This part is just about fetching matches.
      const matchList = readState.unknown.matchLists[name];
      const visibleMatches = matchList.matches.filter(
        ({ id }) =>
          state.transient?.visibleMatches?.[definition.shortName]?.[id],
      );
      await Promise.all(
        visibleMatches.map(({ id }, i) => {
          return getData(
            {
              id,
              isWinner: Math.random() < 0.5,
              timestamp: Date.now() - 1000 * 60 * 60 * 3 * i,
            },
            UnknownMatch,
            ["unknown", "matches", id],
            {
              shouldFetchIfPathExists: false,
            },
          );
        }),
      );
    },
  },
  {
    path: /^\/unknown\/match\/(.*)/,
    component: "game-unknown/Match.jsx",
    async fetchData([matchId]) {
      await getData(
        {
          id: matchId,
          isWinner: Math.random() < 0.5,
          timestamp: Date.now() - 1000 * 60 * 60 * 1,
        },
        UnknownMatch,
        ["unknown", "matches", matchId],
        {
          shouldFetchIfPathExists: false,
        },
      );
    },
  },
];

// The catch-all route should be used for fetching any general static data that is
// related to the routes.
routes.push({
  [catchAllRoutes]: routes,
  fetchData() {},
});

export default routes;
